import { render, staticRenderFns } from "./form.producto.proveedor.vue?vue&type=template&id=f2090c5c&scoped=true&"
import script from "./form.producto.proveedor.vue?vue&type=script&lang=js&"
export * from "./form.producto.proveedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2090c5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAutocomplete,VListItem,VListItemContent,VListItemTitle,VProgressCircular})
